import React from 'react';
import { path, prop } from 'ramda';
import { Icon } from 'js/components/common/Icon';
import { useGameConfigurationSelector } from 'js/store/hooks';
import { usePortletDispatch, usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';
import { deleteFilterAction } from './actions';

import style from './index.scss';

export const Tags = () => {
    const games = useGameConfigurationSelector(prop('games'));
    const categories = usePortletSelector(prop('categories'));
    const selectedCategories = usePortletSelector(path(['filters', 'selectedCategories']));
    const translate = usePortletTranslations();
    const dispatch = usePortletDispatch();

    const categoriesTags = selectedCategories.map((id) => {
        const { displayName, mostPlayedGameCode } = categories.find(cat => cat.cid === id);
        const gameName = games[mostPlayedGameCode]?.name || '';

        return {
            id,
            label: translate(displayName, [gameName])
        };
    });

    return (
        categoriesTags.length > 0 && <div className={style.tagsContainer}>
            <div className={style.tags}>
                {categoriesTags.map(({ label, id }) => (
                    <div key={id} className={style.tag}>
                        {label}
                        <Icon
                            type="clearTag"
                            className={style.icon}
                            onClick={() => dispatch(deleteFilterAction(id))}
                            aria-label={translate('filter.category.aria-label.close', [label])}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Tags;
